import { render } from "./ProjectProcureEndDateModal.vue?vue&type=template&id=472435ce&scoped=true&ts=true"
import script from "./ProjectProcureEndDateModal.ts?vue&type=script&lang=ts"
export * from "./ProjectProcureEndDateModal.ts?vue&type=script&lang=ts"

import "./ProjectProcureEndDateModal.scss?vue&type=style&index=0&id=472435ce&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472435ce"]])

export default __exports__